import { ValueContainerProps, GroupBase, components } from 'react-select';
import { HTMLAttributes } from 'react';
import { BaseOption } from './types';

export const SelectValueContainer = (
  props: ValueContainerProps<BaseOption<string>, boolean, GroupBase<BaseOption<string>>>,
) => {
  return (
    <components.ValueContainer
      {...props}
      innerProps={
        {
          ...props.innerProps,
          'data-test': 'select-value-container',
        } as HTMLAttributes<HTMLDivElement>
      }
    />
  );
};
